var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav"},[_c('ul',[_c('li',{on:{"click":_vm.goMain}},[_vm._v("首页")]),_c('li',{on:{"click":_vm.goAllOrder}},[_vm._v("订单")]),_c('li',[_vm._v("留言")]),_c('li',[_vm._v("设置")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }